export default {
  apiUrl: "https://wisehandler.wisemonkeys.info/",
  mainWebsiteUrl: "https://wisemonkeys.info/",
};
